import TranslatableText from "../../../components/translations/TranslatableText";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import ErrorModal from "../../../components/modal/ErrorModal";
import ImportConflictModal from "../../../components/modal/ImportConflictModal";
import EditTagsModal from "./EditTagsModal";
import { ImportProjectResponse } from "@app/features/project/projectTypes";

interface ProjectModalsProps {
  tagsState: {
    isEditTagsModalOpen: boolean;
    closeEditTagsModal: () => void;
    projectToEditTags: any;
    handleSubmitTags: (initialTags: any[], newTags: any[]) => void;
    isEditTagsDialogErrorMessageOpen: boolean;
    closeEditTagsDialogErrorMessage: () => void;
    editTagsErrorMsg: string;
  };
  deleteState: {
    isDeleteDialogOpen: boolean;
    handleCancel: () => void;
    handleDelete: () => void;
    isLoadingDelete: boolean;
    deleteProjectErrorMsg: string;
    isDeleteDialogErrorMessageOpen: boolean;
    closeDeleteDialogErrorMessage: () => void;
  };
  remove: {
    isRemoveDialogOpen: boolean;
    handleCancelRemove: () => void;
    handleRemove: () => void;
    isRemoveMeFromProjectLoading: boolean;
    isRemoveMeFromProjectErrorMessageOpen: boolean;
    removeMeFromProjectErrorMsg: string;
    closeRemoveMeFromProjectErrorMessage: () => void;
  };
  finalize: {
    isFinalizeDialogOpen: boolean;
    handleCancelFinalize: () => void;
    handleFinalize: () => void;
    isFinalizeDialogErrorMessageOpen: boolean;
    finalizeProjectErrorMsg: string;
    closeFinalizeProjectErrorMessage: () => void;
    isLoadingFinalize: boolean;
  };
  copy: {
    isCopyProjectErrorMessageOpen: boolean;
    copyProjectErrorMsg: string;
    closeCopyProjectErrorMessage: () => void;
    isDuplicateWarningOpen: boolean;
    handleConfirmDuplicate: () => Promise<void>;
    handleCancelDuplicate: () => void;
  };
  exportState: {
    isExportWarningOpen: boolean;
    handleConfirmExport: () => void;
    handleCancelExport: () => void;
  };
  importState: {
    isImportErrorMessageOpen: boolean;
    importErrorMsg: string;
    closeImportErrorMessage: () => void;
    isImportExistsDialogOpen: boolean;
    existingProject: ImportProjectResponse | null;
    handleImportForceCopy: () => void;
    handleCancelImportExists: () => void;
  };
}

const ProjectModals = ({ tagsState, deleteState, remove, finalize, copy, exportState, importState }: ProjectModalsProps) => {
  return (
    <>
      <EditTagsModal
        modalOpen={tagsState.isEditTagsModalOpen}
        handleCancel={tagsState.closeEditTagsModal}
        headerText="project.edit_tags"
        projectToEditTags={tagsState.projectToEditTags}
        handleSubmit={(initialTags, newTags) => tagsState.handleSubmitTags(initialTags, newTags)}
      />
      <ErrorModal
        isOpen={tagsState.isEditTagsDialogErrorMessageOpen}
        errorMessage={tagsState.editTagsErrorMsg}
        handleClose={tagsState.closeEditTagsDialogErrorMessage}
      />

      <ConfirmationModal
        open={deleteState.isDeleteDialogOpen}
        onCancel={deleteState.handleCancel}
        onConfirm={deleteState.handleDelete}
        isLoading={deleteState.isLoadingDelete}
        message={<TranslatableText translationKey="project.delete_confirmation" />}
      />
      <ErrorModal
        isOpen={deleteState.isDeleteDialogErrorMessageOpen}
        errorMessage={deleteState.deleteProjectErrorMsg}
        handleClose={deleteState.closeDeleteDialogErrorMessage}
      />


      <ConfirmationModal
        open={remove.isRemoveDialogOpen}
        onCancel={remove.handleCancelRemove}
        onConfirm={remove.handleRemove}
        isLoading={remove.isRemoveMeFromProjectLoading}
        message={<TranslatableText translationKey="project.remove_me_confirmation" />}
        headerText="project.remove_me_header"
      />
      <ErrorModal
        isOpen={remove.isRemoveMeFromProjectErrorMessageOpen}
        errorMessage={remove.removeMeFromProjectErrorMsg}
        handleClose={remove.closeRemoveMeFromProjectErrorMessage}
      />

      <ConfirmationModal
        open={finalize.isFinalizeDialogOpen}
        onCancel={finalize.handleCancelFinalize}
        onConfirm={finalize.handleFinalize}
        message={<TranslatableText translationKey="project.finalize_confirmation" />}
        headerText="project.finalize_header"
        isLoading={finalize.isLoadingFinalize}
      />
      <ErrorModal
        isOpen={finalize.isFinalizeDialogErrorMessageOpen}
        errorMessage={finalize.finalizeProjectErrorMsg}
        handleClose={finalize.closeFinalizeProjectErrorMessage}
      />

      <ConfirmationModal
        open={copy.isDuplicateWarningOpen}
        onCancel={copy.handleCancelDuplicate}
        onConfirm={copy.handleConfirmDuplicate}
        message={<TranslatableText translationKey="project.duplicate_b_intact_warning" />}
        headerText="project.duplicate_b_intact_header"
        size="md"
      />

      <ErrorModal
        isOpen={copy.isCopyProjectErrorMessageOpen}
        errorMessage={copy.copyProjectErrorMsg}
        handleClose={copy.closeCopyProjectErrorMessage}
      />

      <ConfirmationModal
        open={exportState.isExportWarningOpen}
        onCancel={exportState.handleCancelExport}
        onConfirm={exportState.handleConfirmExport}
        message={<TranslatableText translationKey="project.export_b_intact_warning" />}
        headerText="project.duplicate_b_intact_header"
        size="md"
      />

      <ImportConflictModal
        isOpen={importState.isImportExistsDialogOpen}
        projectId={importState.existingProject?.projectId ?? 0}
        projectName={importState.existingProject?.projectName ?? ""}
        onClose={importState.handleCancelImportExists}
        onImportAsCopy={importState.handleImportForceCopy}
      />
      <ErrorModal
        isOpen={importState.isImportErrorMessageOpen}
        errorMessage={importState.importErrorMsg}
        handleClose={importState.closeImportErrorMessage}
      />
    </>
  );
};

export default ProjectModals; 